import axios from 'axios';

const getLocationByMediaId= (mediaId: number) => axios.get(`medias/${mediaId}/locations`);

export default { 
    getLocationByMediaId
};